<template>
  <div>
    <!-- tab menus -->
    <div class="tabs is-centered is-boxed">
      <ul>
        <li
          @click="tabChanged(tab)"
          :class="{'is-active': tab === selectedType}"
          :key="tab"
          v-for="tab in tabs"
        >
          <a>{{tab}}</a>
        </li>
      </ul>
    </div>

    <!-- search and filter -->
    <div class="columns">
      <div class="column is-two-thirds">
        <b-input placeholder="Search" v-model="query"></b-input>
      </div>
      <div class="column is-one-third">
        <div class="block">
          <b-radio v-model="selectedStatus" native-value="All">All</b-radio>
          <b-radio v-model="selectedStatus" native-value="Enabled">Enabled</b-radio>
          <b-radio v-model="selectedStatus" native-value="Disabled">Disabled</b-radio>
        </div>
      </div>
    </div>

    <!-- topic cards -->
    <div class="columns is-multiline" v-if="topics">
      <div class="column is-one-third" :key="topic.id" v-for="topic in topics">
        <div class="card">
          <div class="card-content">
            <div class="media">
              <div class="media-left" v-if="topic.image_url">
                <figure class="image is-48x48">
                  <img @error="imageError" :src="topic.image_url" :alt="topic.name">
                </figure>
              </div>
              <div class="media-content">
                <p class="title is-4">{{topic.name}}</p>
                <p class="subtitle is-6">{{topic.sport}}</p>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <!-- <a href="#" class="card-footer-item" v-if="!topic.enabled">Enable</a>
            <a href="#" class="card-footer-item has-text-danger" v-else>Disable</a>-->
            <router-link class="card-footer-item" :to="`topics/${topic.id}`">View</router-link>
          </footer>
        </div>
      </div>
    </div>
    <loading v-else></loading>
  </div>
</template>

<script>
import { GET_TOPICS } from "@/store/actions";
import {
  SET_TOPICS_FILTER_QUERY,
  SET_TOPICS_FILTER_TYPE,
  SET_TOPICS_FILTER_STATUS
} from "@/store/mutations";
import Loading from "@/components/Loading";

export default {
  name: "topics",
  components: {
    Loading
  },
  computed: {
    data() {
      return this.$store.state.topics.data;
    },
    query: {
      get() {
        return this.$store.state.topics.query;
      },
      set(v) {
        this.$store.commit(SET_TOPICS_FILTER_QUERY, v);
      }
    },
    selectedStatus: {
      get() {
        return this.$store.state.topics.selectedStatus;
      },
      set(v) {
        this.$store.commit(SET_TOPICS_FILTER_STATUS, v);
      }
    },
    selectedType() {
      return this.$store.state.topics.selectedType;
    },
    tabs() {
      let { data } = this;
      let initial = [
        "All",
        "Football",
        "Rugby",
        "Cricket",
        "Tennis",
        "Golf",
        "Motorsport"
      ];
      if (!data) {
        return initial;
      }

      return initial
        .concat(this.data.map(x => x.sport))
        .filter((value, index, self) => {
          return self.indexOf(value) === index;
        });
    },
    topics() {
      let { data, selectedType, selectedStatus, query } = this;

      if (!data) {
        return data;
      }

      let topicItems = [...data];

      if (selectedType !== "All") {
        topicItems = topicItems.filter(x => x.sport === selectedType);
      }

      if (selectedStatus !== "All") {
        topicItems = topicItems.filter(
          x => x.enabled === (selectedStatus === "Enabled")
        );
      }

      if (query && query.trim().length > 0) {
        let queryLowercased = query.trim().toLowerCase();
        topicItems = topicItems.filter(
          x => x.name.toLowerCase().indexOf(queryLowercased) > -1
        );
      }

      return topicItems;
    }
  },
  mounted() {
    if (!this.data || this.data.length <= 0) {
      this.$store.dispatch(GET_TOPICS);
    }
  },
  methods: {
    tabChanged(tabName) {
      this.$store.commit(SET_TOPICS_FILTER_QUERY, "");
      this.$store.commit(SET_TOPICS_FILTER_TYPE, tabName);
    },
    imageError(e) {
      e.target.src = "https://www.supersport.com/images/placeholder-flag.png";
    }
  }
};
</script>


<style scoped>
.tab-content {
  visibility: hidden;
  display: none;
}
</style>
